<template>
  <footer
    class="white--text mt-0">
    <section
      class="footer-contact">
      <v-container>
        <app-links
          class="mb-6">
        </app-links>
        <div
          class="mb-6">
          <provider-links
            class="mb-5">
          </provider-links>
          <suscription
            v-if="false">
          </suscription>
          <affiliation>
          </affiliation>
        </div>
        <social-links>
        </social-links>
      </v-container>
    </section>
    <section class="footer-copyright">
      <v-container
        class="pt-0">
        <v-divider class="grey lighten-2 my-6" />
        <v-row>
          <v-col
            class="pa-0 text-center text-body-2"
            cols="12"
            md="4"
            offset-md="4">
            <span>Eventeros ® {{ thisYear }}</span>
            <span class="hidden-xs-only"> - </span>
            <br class="hidden-sm-and-up">
            <span>Todos los derechos reservados</span>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </footer>
</template>

<script>

import AppLinks from './AppLinks.vue';
import ProviderLinks from './ProviderLinks.vue';
import Suscription from './Suscription.vue';
import Affiliation from './Affiliation.vue';
import SocialLinks from './SocialLinks.vue';

export default {
  name: 'Footer',
  computed: {
    thisYear() {
      const d = new Date();
      const year = d.getFullYear();
      return year;
    },
  },
  components: {
    AppLinks,
    ProviderLinks,
    Suscription,
    Affiliation,
    SocialLinks,
  },
};
</script>

<style lang="scss" scoped>

footer {
  position: relative;

  .footer-contact {
    background: #65416D;
    padding-top: 60px;

    &>.container {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      &>div {
        flex: 1;
        flex-basis: 0;
        min-width: 0;
      }

      @media screen and (max-width: 960px) {
        text-align: center !important;
        flex-direction: column;
        align-items: center;
      }
    }
  }

  .footer-copyright {
    background: #65416D!important;
    padding: 0.7rem 0;

    a {
      .fa{
        &.fa-youtube{
          font-size: 20px;
        }
      }
    }
  }
}

</style>
